import React, { FC, useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import { Link, useHistory, useLocation, useParams } from 'react-router-dom'
import { LangValue } from '../../../../states/types/common'
import { getGetPrams, setPath, setUrlId } from '../../../../utils/url'
import { URL } from '../../../constants/url'
import Tips from '../../../components/common/Tips'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { fetchTaskReportLabelGroupCategory } from '../../../../states/containers/task/taskSlice'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../../../states/containers/store'
import { endOfMonth, format, nowDate, secToHour, secToMinute, startOfMonth } from '../../../../utils/date'
import { uniqueId } from 'lodash'
import LoadingSquare from '../../../components/common/LoadingSquare'
import DateModule from '../../../components/task/MonthCalendarModule'
import { RequestGetTaskReportLabelGroupCategory } from '../../../../states/types/task'
import { updateTaskSearchQuery } from '../../../../states/containers/common/currentSlice'

interface LabelGroups {
  id: number
  name: string
  code: string | null
  color: string
}
interface LabelGroupCategories {
  id: number
  name: string
  color: string
  parent_id: number | null
  label_groups: LabelGroups[]
  label_group_count: number
  time: {
    scheduled: number | null // 予定時間
    actual: number // 実際にかかった時間
  }
  cost: {
    scheduled: number | null // 予算
    actual: number // 実際にかかったコスト
    other: number // その他コスト
  }
}

interface GetParams {
  team_ids: string
  member_ids: string
  keywords: string
  disabled: string
  key: string
  direction: string
  colors: string
  creator_member_ids: string
  viewer_member_ids: string
  user_member_ids: string
  date: string
}

const DISPLAY_PROJECT_LIMIT = 10

const Index: FC = () => {
  const {
    task,
    login,
    commonPart,
    current,
  } = useSelector((state: RootState) => state)

  const history = useHistory()
  const { language } = useParams<{ language: LangValue }>()
  const location = useLocation()
  const dispatch = useDispatch()

  const [data, setData] = useState<LabelGroupCategories[]>([])
  const [openLabelGroupCategoryIds, setOpenLabelGroupCategoryIds] = useState<(number | null)[]>([])
  const [isDisplayList, setIsDisplayList] = useState<boolean>(false)

  const [isDisplayAllDate, setIsDisplayAllDate] = useState<boolean>(true)
  const [date, setDate] = useState<string>(nowDate("YYYY-MM-01"))

  const [displayProjectPageList, setDisplayProjectPageList] = useState<{ projectId: number, page: number }[]>([])

  const clickDetail = (id: number) => {
    if (!isDisplayAllDate) {
      history.push(`${setPath(setUrlId(URL.TASK_CATEGORY_DETAIL_DETAIL.path, 'id', id), language)}?date=${date}`)
      return
    }
    history.push(`${setPath(setUrlId(URL.TASK_CATEGORY_DETAIL_DETAIL.path, 'id', id), language)}`)
  }

  const getChildrenIds = (parentId: number | null): (number | null)[] => {
    const idList = data.filter((v) => v.parent_id === parentId && v.id !== null).map((v) => v.id)
    if (!idList) return []
    return [...idList, ...idList.map((v) => getChildrenIds(v)).flat()]
  }

  const isExistLabelGroupCategoryId = (id: number | null) => openLabelGroupCategoryIds.includes(id)

  const toggleLabelGroupCategoryId = (id: number | null) => {
    if (isExistLabelGroupCategoryId(id)) {
      const closeIds = [id, ...getChildrenIds(id)]
      setOpenLabelGroupCategoryIds(openLabelGroupCategoryIds.filter((v) => !closeIds.includes(v)))
    } else {
      setOpenLabelGroupCategoryIds([...openLabelGroupCategoryIds, id])
    }
  }

  const createDisplayList = (level: number, parent_id?: number) => {
    const currentLabelGroupCategoryIds = data.map((v) => v.id)
    if (!level && data.filter((v) => v.parent_id === null || !currentLabelGroupCategoryIds.includes(v.parent_id)).length) {
      return data.filter((v) => v.parent_id === null || !currentLabelGroupCategoryIds.includes(v.parent_id))
    }
    return data.filter((v) => v.parent_id === parent_id)
  }

  const buildCategoryList = (level = 0, parent_id?: number, rules?: boolean[]):JSX.Element => {
    const list = createDisplayList(level, parent_id)
    if (!list.length) return (<></>)
    const levelCount = level + 1
    return (
      <>
        {
          list.map((v, i) => {
            const ruleList = [...rules?.map((rule, index) => (rules.length === index + 1 ? !rule : rule)) || [], list.length === i + 1]
            return (
              <>
                <div className="row">
                  <div>
                    <Tips
                      description="レポートを見る"
                      className=""
                      icon={false}
                    >
                      <>
                        <button
                          type="button"
                          onClick={() => clickDetail(v.id)}
                          style={{
                            fontSize: "10px",
                            border: "solid 1px #CCCCCC",
                            borderRadius: "4px",
                          }}
                        >
                          レポート
                        </button>
                      </>
                    </Tips>
                  </div>
                  <div>
                    {
                      ruleList.map((w, j) => {
                        if (!j) return (<React.Fragment key={`${v.name}_${j + 0}_${level}`} />)
                        return (
                          <div
                            key={`${v.name}_${j + 0}_${level}`}
                            style={{
                              width: "14px",
                            }}
                          >
                            {
                              ruleList.length === j + 1 ? (
                                <>
                                  {w ? (<>┗</>) : (<>┣</>)}
                                </>
                              ) : (
                                <>
                                  {w && (<>┃</>)}
                                </>
                              )
                            }
                          </div>
                        )
                      })
                    }
                    <div className="row_name_area">
                      <FontAwesomeIcon
                        icon={['fas', 'folder']}
                        className="icon"
                        style={{
                          color: v.color,
                          fontSize: "20px",
                        }}
                      />
                      {v.name}
                    </div>
                  </div>
                  <div>
                    {
                      login.permissions?.high_volume ? (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "baseline",
                            gap: "2px",
                          }}
                        >
                          <div
                            style={{
                              fontSize: "22px",
                            }}
                          >
                            {v.label_group_count || 0}
                          </div>
                          件のプロジェクトがあります
                        </div>
                      ) : (
                        <>
                          {
                            v.label_groups.map((labelGroup) => (
                              <div
                                className="member_block"
                                key={`condition_${labelGroup.id}`}
                              >
                                <div
                                  style={{
                                    backgroundColor: labelGroup.color,
                                    width: "16px",
                                    height: "16px",
                                    borderRadius: "50%",
                                  }}
                                />
                                {labelGroup.name}
                              </div>
                            ))
                          }
                        </>
                      )
                    }
                  </div>
                </div>
                {buildCategoryList(levelCount, v.id, ruleList)}
              </>
            )
          })
        }
      </>
    )
  }

  const buildCategoryBlock = (level = 0, parent_id?: number, rules?: boolean[]):JSX.Element => {
    const list = createDisplayList(level, parent_id)
    if (!list.length) return (<></>)
    const levelCount = level + 1
    return (
      <>
        {
          list.map((v, i) => {
            const ruleList = [...rules?.map((rule, index) => (rules.length === index + 1 ? !rule : rule)) || [], list.length === i + 1]
            return (
              <React.Fragment key={`category_name_${v.name}`}>
                <div className="category_block_wrapper">
                  {
                    !!level && (
                      <div
                        style={{
                          width: `${level * 16}px`,
                        }}
                      />
                    )
                  }
                  <div className="category_block">
                    <div
                      className="tag"
                      style={{
                        backgroundColor: v.color,
                      }}
                    >
                      <div
                        className="tag_text"
                      >
                        カテゴリー名：
                        {v.name}
                      </div>
                    </div>
                    <div
                      className="category_block_detail_wrapper"
                      style={{
                        backgroundColor: v.color,
                      }}
                    >
                      <div className="category_block_detail">
                        <div className="category_block_detail_title">
                          <div className="category_name">
                            <FontAwesomeIcon
                              icon={['fas', 'folder']}
                              className="icon"
                              style={{
                                color: v.color,
                              }}
                            />
                            <div>
                              {v.name}
                            </div>
                          </div>
                          <button
                            type="button"
                            onClick={() => clickDetail(v.id)}
                          >
                            カテゴリーレポートを見る
                            <FontAwesomeIcon
                              icon={['fas', 'angle-double-right']}
                              className="icon"
                            />
                          </button>
                        </div>
                        <div className="category_block_detail_values">
                          <div>
                            <FontAwesomeIcon
                              icon={['far', 'clock']}
                              className="icon"
                              style={{
                                fontSize: "20px",
                              }}
                            />
                            <div className="value_wrapper">
                              <div className="value_block">
                                <div className="value_label scheduled">
                                  予定合計
                                </div>
                                <div
                                  style={{
                                    color: isExistLabelGroupCategoryId(v.id) ? "#CCCCCC" : "#666666",
                                  }}
                                >
                                  {
                                    !v.time.scheduled ? (
                                      <>
                                        <span
                                          style={{
                                            fontSize: "20px",
                                          }}
                                        >
                                          -
                                        </span>
                                      </>
                                    ) : (
                                      <>
                                        {
                                          Number(secToHour(v.time.scheduled)) > 0
                                            ? (
                                              <>
                                                <span
                                                  style={{
                                                    fontSize: "20px",
                                                  }}
                                                >
                                                  {secToHour(v.time.scheduled)}
                                                </span>
                                                時間
                                              </>
                                            )
                                            : ""
                                        }
                                        {
                                          Number(secToMinute(v.time.scheduled)) > 0
                                            ? (
                                              <>
                                                <span
                                                  style={{
                                                    fontSize: "20px",
                                                  }}
                                                >
                                                  {secToMinute(v.time.scheduled)}
                                                </span>
                                                分
                                              </>
                                            )
                                            : ""
                                        }
                                      </>
                                    )
                                  }
                                </div>
                              </div>
                              <div className="value_block">
                                <div className="value_label actual">
                                  実績合計
                                </div>
                                <div
                                  style={{
                                    color: isExistLabelGroupCategoryId(v.id) ? "#CCCCCC" : "#666666",
                                  }}
                                >
                                  {
                                    !v.time.actual && (
                                      <>
                                        <span
                                          style={{
                                            fontSize: "20px",
                                          }}
                                        >
                                          -
                                        </span>
                                      </>
                                    )
                                  }
                                  {
                                    Number(secToHour(v.time.actual)) > 0
                                      ? (
                                        <>
                                          <span
                                            style={{
                                              fontSize: "20px",
                                            }}
                                          >
                                            {secToHour(v.time.actual)}
                                          </span>
                                          時間
                                        </>
                                      )
                                      : ""
                                  }
                                  {
                                    Number(secToMinute(v.time.actual)) > 0
                                      ? (
                                        <>
                                          <span
                                            style={{
                                              fontSize: "20px",
                                            }}
                                          >
                                            {secToMinute(v.time.actual)}
                                          </span>
                                          分
                                        </>
                                      )
                                      : ""
                                  }
                                </div>
                              </div>
                            </div>
                          </div>
                          {
                            login.permissions?.task_cost_view && (
                              <>
                                <div>
                                  <FontAwesomeIcon
                                    icon={['fas', 'coins']}
                                    className="icon"
                                    style={{
                                      fontSize: "20px",
                                    }}
                                  />
                                  <div className="value_wrapper">
                                    <div className="value_block">
                                      <div className="value_label scheduled">
                                        予定合計
                                      </div>
                                      <div
                                        style={{
                                          color: isExistLabelGroupCategoryId(v.id) ? "#CCCCCC" : "#666666",
                                        }}
                                      >
                                        <span
                                          style={{
                                            fontSize: "20px",
                                          }}
                                        >
                                          {(v.cost.scheduled || 0).toLocaleString()}
                                        </span>
                                        円
                                      </div>
                                    </div>
                                    <div className="value_block">
                                      <div className="value_label actual">
                                        実績合計
                                      </div>
                                      <div
                                        style={{
                                          color: isExistLabelGroupCategoryId(v.id) ? "#CCCCCC" : "#666666",
                                        }}
                                      >
                                        <span
                                          style={{
                                            fontSize: "20px",
                                          }}
                                        >
                                          {v.cost.actual.toLocaleString()}
                                        </span>
                                        円
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </>
                            )
                          }
                        </div>
                        <div className="category_block_detail_project">
                          <div
                            className="project_title"
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "flex-end",
                            }}
                          >
                            <div>
                              プロジェクト
                            </div>
                            <div>
                              {`全${v.label_group_count || 0}件`}
                            </div>
                          </div>
                          <div className="project_chip_wrapper">
                            {
                              login.permissions?.high_volume ? (
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "baseline",
                                    gap: "2px",
                                  }}
                                >
                                  <div
                                    style={{
                                      fontSize: "22px",
                                    }}
                                  >
                                    {v.label_group_count || 0}
                                  </div>
                                  件のプロジェクトがあります
                                </div>
                              ) : (
                                <>
                                  {
                                    // eslint-disable-next-line max-len
                                    v.label_groups.slice(0, (displayProjectPageList.find((w) => w.projectId === v.id)?.page || 1) * DISPLAY_PROJECT_LIMIT).map((labelGroup) => (
                                      <div
                                        className="project_chip"
                                        key={`project_chip_${labelGroup.id}`}
                                      >
                                        <div
                                          style={{
                                            backgroundColor: labelGroup.color,
                                          }}
                                        />
                                        {labelGroup.name}
                                      </div>
                                    ))
                                  }
                                </>
                              )
                            }
                          </div>
                          {
                            !login.permissions?.high_volume
                            && (displayProjectPageList.find((w) => w.projectId === v.id)?.page || 1) * DISPLAY_PROJECT_LIMIT < v.label_group_count
                            && (
                              <button
                                type="button"
                                // eslint-disable-next-line max-len
                                onClick={() => setDisplayProjectPageList((cur) => cur.map((w) => (w.projectId === v.id ? { ...w, page: w.page + 1 } : w)))}
                                style={{
                                  width: "100%",
                                  textAlign: "center",
                                  border: "solid 1px #CCCCCC",
                                  borderRadius: "4px",
                                  marginTop: "16px",
                                  backgroundColor: "#EEEEEE",
                                }}
                              >
                                もっと見る
                              </button>
                            )
                          }
                        </div>
                      </div>
                      {
                        !!data.filter((w) => w.parent_id === v.id).length && (
                          <button
                            type="button"
                            className="open_folder_button"
                            onClick={() => toggleLabelGroupCategoryId(v.id)}
                          >
                            <FontAwesomeIcon
                              icon={['fas', isExistLabelGroupCategoryId(v.id) ? 'folder-open' : 'folder']}
                              className="icon"
                              style={{
                                color: v.color,
                              }}
                            />
                            {isExistLabelGroupCategoryId(v.id) ? "子カテゴリーを閉じる" : "子カテゴリーを開く"}
                          </button>
                        )
                      }
                      {isExistLabelGroupCategoryId(v.id) && buildCategoryBlock(levelCount, v.id, ruleList)}
                    </div>
                  </div>
                </div>
              </React.Fragment>
            )
          })
        }
      </>
    )
  }

  const createCategory = () => {
    history.push({
      pathname: setPath(URL.TASK_PROJECT_CATEGORY.path, language),
      state: { create: true },
    })
  }

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [location])

  useEffect(() => {
    setData(task.taskReportLabelGroupCategory?.label_group_categories || [])
  }, [task.taskReportLabelGroupCategory])

  useEffect(() => {
    const query = []
    const params: RequestGetTaskReportLabelGroupCategory = {}
    setData([])
    if (!isDisplayAllDate) {
      params.start_date = startOfMonth(date, "YYYY-MM-DD")
      params.end_date = endOfMonth(date, "YYYY-MM-DD")
      query.push(`date=${date}`)
    }
    dispatch(fetchTaskReportLabelGroupCategory(
      params,
    ))
    if (current.taskSearchQuery) {
      const getParams = getGetPrams(current.taskSearchQuery) as GetParams
      if (isDisplayAllDate) {
        getParams.date = ""
      } else {
        getParams.date = date
      }
      dispatch(updateTaskSearchQuery(new URLSearchParams({ ...getParams }).toString()))
    }
    history.push(`${setPath(URL.TASK_CATEGORY_DETAIL.path, language)}?${query.join('&')}`)
  }, [isDisplayAllDate, date])

  useEffect(() => {
    if (!current.taskSearchQuery) return
    const getParams = getGetPrams(current.taskSearchQuery) as GetParams
    if (getParams.date) {
      setDate(getParams.date)
      setIsDisplayAllDate(false)
    }
  }, [])

  useEffect(() => {
    setDisplayProjectPageList(data.map((v) => ({ projectId: v.id, page: 1 })))
  }, [data])

  return (
    <section className="task_page">
      <Helmet>
        <title>Qasee - 工数管理 - カテゴリーレポート</title>
      </Helmet>
      <section className="breadcrumb">
        <Link
          to={setPath(URL.TASK.path, language)}
        >
          工数管理
        </Link>
        &nbsp;&gt;&nbsp;
        カテゴリーレポート
        &nbsp;
      </section>
      <section className="page_header">
        <h1>
          カテゴリーレポート
        </h1>
        <div className="tools">
          <div className="button_area">
            {
              login.permissions?.task_project_setting && (
                <button
                  type="button"
                  className="button"
                  onClick={createCategory}
                >
                  <FontAwesomeIcon icon={['fas', 'plus']} />
                  &nbsp;
                  カテゴリーを新規作成する
                  &nbsp;
                  <FontAwesomeIcon icon={['fas', 'external-link-alt']} />
                </button>
              )
            }
          </div>
        </div>
      </section>
      <section className="page_description">
        <p>
          プロジェクトをまとめたカテゴリーレポートを閲覧できます。
        </p>
        <p>
          複数プロジェクトの集計データをご活用いただけます。
        </p>
      </section>
      <section className="page_contents content-area">
        <div className="content-block">
          <div className="block-header">
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}
            >
              <div className="title" style={{ margin: "0px" }}>
                カテゴリーレポート一覧
              </div>
              <div className="button_area" key={uniqueId()}>
                {
                  isDisplayList ? (
                    <>
                      <Tips
                        description="カテゴリー表示に切り替えます"
                        className=""
                        icon={false}
                      >
                        <>
                          <button
                            type="button"
                            onClick={() => setIsDisplayList(false)}
                            style={{
                              border: "1px solid #cccccc",
                              borderRadius: "4px",
                              padding: "4px 6px",
                              display: "flex",
                              gap: "4px",
                            }}
                          >
                            <FontAwesomeIcon icon={['fas', 'list-ul']} />
                            <FontAwesomeIcon icon={['fas', 'arrow-right']} />
                            <FontAwesomeIcon icon={['fas', 'folder']} />
                          </button>
                        </>
                      </Tips>
                    </>
                  ) : (
                    <>
                      <Tips
                        description="リスト表示に切り替えます"
                        className=""
                        icon={false}
                      >
                        <>
                          <button
                            type="button"
                            onClick={() => setIsDisplayList(true)}
                            style={{
                              border: "1px solid #cccccc",
                              borderRadius: "4px",
                              padding: "4px 6px",
                              display: "flex",
                              gap: "4px",
                            }}
                          >
                            <FontAwesomeIcon icon={['fas', 'folder']} />
                            <FontAwesomeIcon icon={['fas', 'arrow-right']} />
                            <FontAwesomeIcon icon={['fas', 'list-ul']} />
                          </button>
                        </>
                      </Tips>
                    </>
                  )
                }
              </div>
            </div>
            <div>
              {
                !!task.taskReportLabelGroupCategory?.threshold_time && (
                  <>
                    {`${format(task.taskReportLabelGroupCategory?.threshold_time, "YYYY年M月D日HH時mm分ss秒")}時点の集計データを表示しています`}
                  </>
                )
              }
            </div>
          </div>
          <div className="block-header">
            <div />
            <div className="tools">
              <button
                type="button"
                className={`display_switch ${isDisplayAllDate ? "check" : ""}`}
                onClick={() => setIsDisplayAllDate(!isDisplayAllDate)}
              >
                <div>
                  <FontAwesomeIcon icon={['far', 'calendar-alt']} />
                  <span>
                    全期間
                  </span>
                </div>
                <div>
                  <FontAwesomeIcon icon={['far', 'calendar-check']} />
                  <span>
                    月別
                  </span>
                </div>
              </button>
              <DateModule
                date={date}
                startMonth={format(commonPart.company?.created_at, "YYYYMM")}
                changeCallback={(callback_date) => {
                  setDate(callback_date)
                  history.push(`${location.pathname}?date=${callback_date}`)
                }}
                disabled={isDisplayAllDate}
              />
            </div>
          </div>
          <div className="block-detail">
            {
              task.isLoading ? (
                <LoadingSquare>
                  <>
                    カテゴリーを読み込んでいます…
                  </>
                </LoadingSquare>
              ) : (
                <>
                  {
                    data.length ? (
                      <>
                        {
                          isDisplayList ? (
                            <>
                              <div className="project_category_table">
                                <div className="row_head">
                                  <div>
                                    閲覧
                                  </div>
                                  <div>
                                    プロジェクトカテゴリー名
                                  </div>
                                  <div>
                                    プロジェクト
                                  </div>
                                </div>
                                {buildCategoryList()}
                              </div>
                            </>
                          ) : (
                            <>
                              {buildCategoryBlock()}
                            </>
                          )
                        }
                      </>
                    ) : (
                      <>
                        <div className="no_data_area">
                          <div className="no_data">
                            対象のプロジェクトカテゴリーはありません
                          </div>
                        </div>
                      </>
                    )
                  }
                </>
              )
            }
          </div>
        </div>
      </section>
    </section>
  )
}

export default Index
